module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"files:no-files":"Файлы отсутствуют"},"en":{"files:no-files":"No file"}}')
  delete Component.options._Ctor
}
